import React, { useEffect, useState } from 'react'
import MobileCustomFilter from '../../../../../../customComponents/MobileCustomFilter'
import Pagenation from '../../../../../Desktop/GlobalComponents/User/Pagenation'

const MobileSponserComm = ({
	sponserCommissionsData,
	totalItems,
	itemsPerPage,
	currentPage,
	searchTerm,
	startDate,
	endDate,
	handleSearch,
	handleDateChange,
	handleItemsPerPageChange,
	handlePageChange,
	handleSubmit,
	handleRedirectTORefCommTree,
}) => {
	useEffect(() => {
		// Reset styles to allow scrolling
		document.body.style.overflow = 'auto'
		document.body.style.paddingRight = '0px'

		// If a second div exists, reset its styles
		const secondDiv = document.body.children[1] // Adjust selector if needed
		if (secondDiv) {
			secondDiv.style.position = 'static'
			secondDiv.style.zIndex = 'auto'
			secondDiv.style.inset = 'auto'
			secondDiv.style.pointerEvents = 'auto'
		}

		return () => {
			// Cleanup styles to avoid conflicts on unmount
			document.body.style.overflow = ''
			document.body.style.paddingRight = ''
			if (secondDiv) {
				secondDiv.style.position = ''
				secondDiv.style.zIndex = ''
				secondDiv.style.inset = ''
				secondDiv.style.pointerEvents = ''
			}
		}
	}, [])
	const [localStartDate, setLocalStartDate] = useState(startDate)
	const [localEndDate, setLocalEndDate] = useState(endDate)

	useEffect(() => {
		setLocalStartDate(startDate)
		setLocalEndDate(endDate)
	}, [startDate, endDate])

	const handleLocalDateChange = ({ startDate, endDate }) => {
		setLocalStartDate(startDate)
		setLocalEndDate(endDate)
		handleDateChange({ startDate, endDate })
	}

	const handleLocalSubmit = () => {
		handleSubmit()
	}

	return (
		<div className='mb-0 mt-6 display-mob'>
			<div class='card container-fluid w-95 mb-2 shadow-card '>
				<div className='row d-flex justify-content-between align-items-center '>
					<div className=' col-9 text-center'>
						<h3 className=' letter-normal text-normal text-black'>Sponsor Commission</h3>
					</div>
					<div className=' col-3 title-card-bg'>
						<img
							className='title-card-image ms-n1'
							src='https://cdn.prod.website-files.com/5e3c1236f9bdda2d49bbe89f/649d48d46c76fa917afb2135_referral.png'
							alt=''
						/>
					</div>
				</div>
			</div>

			<MobileCustomFilter
				itemsPerPage={itemsPerPage}
				handleItemsPerPageChange={handleItemsPerPageChange}
				startDate={localStartDate}
				endDate={localEndDate}
				handleDateChange={handleLocalDateChange}
				handleSubmit={handleLocalSubmit}
				searchTerm={searchTerm}
				handleSearch={handleSearch}
			/>
			{sponserCommissionsData?.length > 0 ? (
				sponserCommissionsData.map((item, index) => (
					<MobileSponserCommCard
						key={item._id?.toString() || index}
						data={item}
						index={index}
						handleRedirectTORefCommTree={handleRedirectTORefCommTree}
					/>
				))
			) : (
				<div className='card mt-4 container w-95 mb-2 text-center p-4'>
					<p className='text-dark'>No Data Available</p>
				</div>
			)}
			<div
				style={{
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<Pagenation totalItems={totalItems} itemsPerPage={itemsPerPage} currentPage={currentPage} onPageChange={handlePageChange} />
			</div>
		</div>
	)
}

const MobileSponserCommCard = ({ data, index, handleRedirectTORefCommTree }) => {
	return (
		<div className='card shadow mt-2 container-fluid  shadow-card w-95 mb-2 p-1'>
			<div className='d-flex gap-2 justify-content-between align-items-center mt-2 mb-1 p-1'>
				<span class='bg-dark-yellow sno p-1 ms-1'>
					<b className='text-black-50 text-sm'>{index + 1}</b>
				</span>
				<div className='col-2 p-1 text-center ms-1'>
					<img className='w-100' src={`${process.env.REACT_APP_RESOURCE_URL}${data.profileImg}`} alt='' />
				</div>
				<div className='col-8 mx-auto text-nowrap'>
					<div className='d-flex justify-content-between gap-4 '>
						<div>
							<p className='text-normal text-sm text-black text-wrap'>{data.productName?.join(', ') || ''}</p>
						</div>
					</div>
					<div className='d-flex justify-content-between align-items-center mb-2'>
						<div className='card card-border shadow-card  container-fluid w-95 card-body mb-4'>
							<div className='row d-flex justify-content-lg-start mb-2'>
								<div className='col-6'>
									<div>
										<b className='text-dark fw-normal text-start'>User Id : </b>
									</div>
								</div>
								<div className='col-6'>
									<div>
										<b className='text-dark fw-normal text-start'>{data?.registerId}</b>
									</div>
								</div>
							</div>
							<div className='row d-flex justify-content-lg-start mb-2'>
								<div className='col-6'>
									<div>
										<b className='text-dark fw-normal text-start'>User Name : </b>
									</div>
								</div>
								<div className='col-6'>
									<div>
										<b className='text-dark fw-normal text-start'>{data?.userName}</b>
									</div>
								</div>
							</div>
							<div className='row d-flex justify-content-lg-start mb-2'>
								<div className='col-6'>
									<div>
										<b className='text-dark fw-normal text-start'>Commission : </b>
									</div>
								</div>
								<div className='col-6'>
									<div>
										<b className='text-dark fw-normal text-start'>{data?.sponserCommission}</b>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<hr className='horizontal dark mt-n2' />
		</div>
	)
}

export default MobileSponserComm
